import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AdobeFlashSvg = function AdobeFlashSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#501002",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7373",
    d: "M9.086 16.167v-3.623h3.593V11.36H9.086V8.934h4.072l.006-1.202H7.645v8.435zm7.134.087c.193 0 .426-.046.636-.116v-.893l-.303-.011c-.479-.041-.683-.333-.683-.858V7.499h-1.388v7.04c0 .858.175 1.715 1.738 1.715"
  }));
};
export var AdobeFlash = function AdobeFlash(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AdobeFlashSvg
  }));
};